// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"680":"a8139746","998":"c1856d13"}[chunkId] + ".chunk.js";
};